// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"491":"7661fac7","946":"127efa34"}[chunkId] + ".css";
};